import React, { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import emailjs from '@emailjs/browser';
import { db } from '../firebase/config';
import { 
  EMAILJS_SERVICE_ID, 
  EMAILJS_TEMPLATE_ID, 
  EMAILJS_PUBLIC_KEY,
  RECIPIENT_EMAIL 
} from '../config/emailjs';
import './Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setStatus('Please enter a valid email address');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setStatus('Please enter a valid email address');
      return;
    }

    setStatus('Subscribing...');

    try {
      // Save to Firestore
      await addDoc(collection(db, 'newsletter'), {
        email: email,
        timestamp: new Date()
      });

      // Send notification email using EmailJS (if configured)
      if (EMAILJS_SERVICE_ID && EMAILJS_TEMPLATE_ID && EMAILJS_PUBLIC_KEY) {
        try {
          await emailjs.send(
            EMAILJS_SERVICE_ID,
            EMAILJS_TEMPLATE_ID,
            {
              to_email: RECIPIENT_EMAIL,
              subscriber_email: email,
              subject: 'New Newsletter Subscription',
              message: `A new user has subscribed to the newsletter:\n\nEmail: ${email}\nDate: ${new Date().toLocaleString()}`
            },
            EMAILJS_PUBLIC_KEY
          );
          console.log('Newsletter subscription email sent successfully');
        } catch (emailError) {
          console.error('EmailJS error (subscription still saved):', emailError);
          // Don't fail the subscription if email fails
        }
      } else {
        console.warn('EmailJS is not configured. Please add your EmailJS credentials to src/config/emailjs.js');
      }

      setStatus('Thank you for subscribing!');
      setEmail('');
    } catch (error) {
      console.error('Error adding document: ', error);
      setStatus('An error occurred. Please try again.');
    }
  };

  return (
    <section className="newsletter-section">
      <div className="newsletter-container">
        <div className="newsletter-content">
          <h2 className="newsletter-title">Get Updates And Stay Connected - Subscribe To Our Newsletter</h2>
          <form className="newsletter-form" onSubmit={handleSubmit}>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="newsletter-input"
            />
            <button type="submit" className="newsletter-button">Subscribe</button>
          </form>
          {status && <p className="newsletter-status">{status}</p>}
        </div>
      </div>
    </section>
  );
};

export default Newsletter;

